// 课卡小程序码类型（card_qr_code.qr_type）
export const cardQrCodeTypes = {
  delay: 1,
  stop: 2,
};

export default cardQrCodeTypes;
